import { render } from "./MaintenanceIssueForm.vue?vue&type=template&id=a5f36736"
import script from "./MaintenanceIssueForm.vue?vue&type=script&lang=js"
export * from "./MaintenanceIssueForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__